// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderCreateInvitationPayload,
    ProviderInvitation,
    ProviderInvitations,
    UserAcceptInvitationPayload,
    ProviderCreateInvitationPayloadToJSON,
    UserAcceptInvitationPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderInvitationFromJSON,
    ProviderInvitationsFromJSON,
} from '../models';

export interface AcceptUserInvitationRequest {
    userAcceptInvitationPayload: UserAcceptInvitationPayload;
}

export interface CreateProviderInvitationRequest {
    providerCreateInvitationPayload: ProviderCreateInvitationPayload;
}

export interface DeleteProviderInvitationRequest {
    id: string;
}

export interface DeleteUserInvitationRequest {
    id: string;
}

export interface GetProviderInvitationRequest {
    id: string;
}

export interface GetUserInvitationRequest {
    id: string;
}

export interface ListProviderInvitationsRequest {
    filterStatus?: Array<string>;
}

/**
 * no description
 */
export class InvitationApi extends runtime.BaseAPI {

    /**
     * Accept user invitation
     * Accept invitation
     */
    async acceptUserInvitationRaw(requestParameters: AcceptUserInvitationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['userAcceptInvitationPayload'] === null || requestParameters['userAcceptInvitationPayload'] === undefined) {
            throw new runtime.RequiredError('userAcceptInvitationPayload','Required parameter requestParameters.userAcceptInvitationPayload was null or undefined when calling acceptUserInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/invitation_accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserAcceptInvitationPayloadToJSON(requestParameters['userAcceptInvitationPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Accept user invitation
     * Accept invitation
     */
    async acceptUserInvitation(requestParameters: AcceptUserInvitationRequest): Promise<ObjectNoResponse> {
        const response = await this.acceptUserInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an invitation
     * Create an invitation
     */
    async createProviderInvitationRaw(requestParameters: CreateProviderInvitationRequest): Promise<runtime.ApiResponse<ProviderInvitations>> {
        if (requestParameters['providerCreateInvitationPayload'] === null || requestParameters['providerCreateInvitationPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateInvitationPayload','Required parameter requestParameters.providerCreateInvitationPayload was null or undefined when calling createProviderInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:invitation"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateInvitationPayloadToJSON(requestParameters['providerCreateInvitationPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderInvitationsFromJSON(jsonValue));
    }

    /**
     * Create an invitation
     * Create an invitation
     */
    async createProviderInvitation(requestParameters: CreateProviderInvitationRequest): Promise<ProviderInvitations> {
        const response = await this.createProviderInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete an invitation
     * Delete
     */
    async deleteProviderInvitationRaw(requestParameters: DeleteProviderInvitationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProviderInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:invitation"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invitation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete an invitation
     * Delete
     */
    async deleteProviderInvitation(requestParameters: DeleteProviderInvitationRequest): Promise<ObjectNoResponse> {
        const response = await this.deleteProviderInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete a user invitation
     * Delete
     */
    async deleteUserInvitationRaw(requestParameters: DeleteUserInvitationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/invitation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete a user invitation
     * Delete
     */
    async deleteUserInvitation(requestParameters: DeleteUserInvitationRequest): Promise<ObjectNoResponse> {
        const response = await this.deleteUserInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an invitation
     * Get a single invitation
     */
    async getProviderInvitationRaw(requestParameters: GetProviderInvitationRequest): Promise<runtime.ApiResponse<ProviderInvitation>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invitation"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invitation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderInvitationFromJSON(jsonValue));
    }

    /**
     * Gets an invitation
     * Get a single invitation
     */
    async getProviderInvitation(requestParameters: GetProviderInvitationRequest): Promise<ProviderInvitation> {
        const response = await this.getProviderInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an invitation by id
     * Get an invitation by id
     */
    async getUserInvitationRaw(requestParameters: GetUserInvitationRequest): Promise<runtime.ApiResponse<ProviderInvitation>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUserInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/invitation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderInvitationFromJSON(jsonValue));
    }

    /**
     * Get an invitation by id
     * Get an invitation by id
     */
    async getUserInvitation(requestParameters: GetUserInvitationRequest): Promise<ProviderInvitation> {
        const response = await this.getUserInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of invitations
     * Get a list of invitations
     */
    async listProviderInvitationsRaw(requestParameters: ListProviderInvitationsRequest): Promise<runtime.ApiResponse<Array<ProviderInvitation>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invitation"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invitation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderInvitationFromJSON));
    }

    /**
     * Gets a list of invitations
     * Get a list of invitations
     */
    async listProviderInvitations(requestParameters: ListProviderInvitationsRequest): Promise<Array<ProviderInvitation>> {
        const response = await this.listProviderInvitationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of invitations
     * Get a list of invitations
     */
    async listUserInvitationsRaw(): Promise<runtime.ApiResponse<Array<ProviderInvitation>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/me/invitation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderInvitationFromJSON));
    }

    /**
     * Gets a list of invitations
     * Get a list of invitations
     */
    async listUserInvitations(): Promise<Array<ProviderInvitation>> {
        const response = await this.listUserInvitationsRaw();
        return await response.value();
    }

}
